// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r8-2";
export var chatLink = "_r8-0";
export var chatText = "_r8-1";